<template>
	<div class="align-center">

		<template v-if="ready">

			<template v-if="!tokenValid">
				<Heading
					:title="translations.labels.resetPassword"
				/>
				<el-alert
					:title="translations.messages.invalidToken"
					:closable="false"
					type="error"
					center
				/>
				<div class="align-center margin-top-20">
					<router-link to="/login">
						<small>{{ translations.labels.backToLogin }}</small>
					</router-link>
				</div>
			</template>

			<template v-else>
				<Heading
					:title="translations.labels.resetPassword"
					:subtitle="translations.labels.setPasswordSubtitle"
				/>
				<el-form
					v-if="tokenValid"
					@submit.prevent.native="submitForm('form')"
					:model="form"
					:rules="rules"
					ref="form"
				>
					<el-form-item prop="password">
						<el-input
							v-model="form.password"
							:placeholder="translations.labels.password"
							type="password"
							suffix-icon="el-icon-lock"
							show-password
						/>
					</el-form-item>
					<el-form-item prop="confirmPassword">
						<el-input
							v-model="form.confirmPassword"
							:placeholder="translations.labels.passwordConfirmation"
							type="password"
							suffix-icon="el-icon-lock"
							show-password
						/>
					</el-form-item>
					<el-form-item>
						<el-button
							:loading="processing"
							native-type="submit"
							type="primary"
							class="wide"
							plain
							round
						>
							{{ translations.labels.reset }}
						</el-button>
					</el-form-item>
				</el-form>
			</template>

		</template>

		<template v-else>
			<Heading
				:title="translations.labels.resetPassword"
				:subtitle="translations.labels.verifyingToken"
			/>
			<div
				v-loading="true"
				style="height: 50px"
			/>
		</template>

	</div>
</template>

<script>
import { _verifyToken, _resetPassword } from '@/services/api/account'

export default {
	name: 'ResetPassword',
	metaInfo () {
		return {
			title: this.translations.labels.resetPassword
		}
	},
	components: {
		Heading: () => import( /* webpackPrefetch: true */ '@/views/Public/Components/Heading')
	},
	data () {
		return {
			form: {
				token: null,
				password: null,
				confirmPassword: null
			},
			processing: false,
			rules: {
				password: [
					{ required: true, message: this.$store.state.translations.messages.enterPassword, trigger: 'change' },
					{ min: 6, message: this.$store.state.translations.messages.passwordLength, trigger: 'change' }
				],
				confirmPassword: [
					{ validator: this.checkPassword, trigger: 'change' },
					{ min: 6, message: this.$store.state.translations.messages.passwordLength, trigger: 'change' }
				]
			},
			tokenValid: false
		}
	},
	created () {
		this.ajaxVerifyToken()
	},
	methods: {

		ajaxVerifyToken () {
			this.form.token = this.$route.params.token
			const data = {
				token: this.$route.params.token
			}
			_verifyToken (data)
				.then(() => {
					this.tokenValid = true
					setTimeout(() => this.$store.dispatch('setReady', true), 1000)
				})
				.catch(() => {
					setTimeout(() => this.$store.dispatch('setReady', true), 1000)
				})
		},
		ajaxResetPassword () {
			this.processing = true
			_resetPassword (this.form)
				.then(() => {
					this.processing = false
					this.displayMessage(this.translations.messages.successChangePassword, 'success')
					this.redirectTo('/login')
				})
				.catch(error => {
					this.processing = false
					const errorCode = error.response.data.status
					this.displayMessage(this.translations.statusCodes[errorCode] ? this.translations.statusCodes[errorCode] : this.translations.statusCodes['default'], 'error')
				})
		},

		submitForm (form) {
			this.$refs[form].validate((valid) => {
				if (valid) {
					this.ajaxResetPassword()
				} else {
					return false
				}
			})
		},
		checkPassword (rule, value, callback) {
			if (!value) {
				callback(new Error(this.translations.messages.confirmNewPassword))
			} else {
				if (value !== this.form.password) {
					callback(new Error(this.translations.messages.confirmNewPassword))
				} else {
					callback()
				}
			}
		}
		
	}
}
</script>
